import React, { useMemo, useCallback } from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import AuditTrailViewer from '../AuditTrail';
import useStyles from './style';


const ActionBarViewer = React.memo((props) => {
   const { 
       isButtonEnable, 
       isExport, 
       isAuditTrail, 
       handleAuditTrailDrawerToggle, 
       auditTrailDrawerOpen, 
       auditTrail, 
       chartUniqueId, 
       label, 
       value, 
       exportLabel, 
       auditTrailLabel, 
       blockState, 
       handleExport, 
       isUpdated, 
       currentDocumentId 
   } = props;
   
   const classes = useStyles();
   
   // Memoize computed values
   const documentId = useMemo(() => {
       return blockState?._id || blockState?.id || currentDocumentId;
   }, [blockState?._id, blockState?.id, currentDocumentId]);
   
   const displayValue = useMemo(() => {
       return blockState?.[value];
   }, [blockState, value]);
   
   const labelText = useMemo(() => {
       return `${label} :`;
   }, [label]);
   
   // Memoize export handler to prevent creating new function on each render
   const handleExportClick = useCallback(() => {
       handleExport(documentId, blockState);
   }, [handleExport, documentId, blockState]);
   
   // Memoize conditional rendering flags
   const showButtons = useMemo(() => {
       return isButtonEnable && isUpdated;
   }, [isButtonEnable, isUpdated]);
   
   const showDrawer = useMemo(() => {
       return isButtonEnable && isAuditTrail;
   }, [isButtonEnable, isAuditTrail]);
   
   // Memoize drawer props to prevent unnecessary re-renders
   const drawerPaperProps = useMemo(() => ({
       className: classes.drawerPaper,
   }), [classes.drawerPaper]);
   
   return (
        <div className={classes.container}>
            <div className={classes.leftContainer}>
                <div className={classes.innerContainer}>
                    <div className={classes.blueBar} />
                    <Typography className={classes.labelText}>{labelText}</Typography>
                    <Typography className={classes.valueText}>{displayValue}</Typography>
                </div>
            </div>
            {showButtons && (
                <div className={classes.buttonContainer}>
                    {isExport && (
                        <Button
                            className={classes.exportButton}
                            onClick={handleExportClick}
                        >
                            {exportLabel}
                        </Button>
                    )}
                    {isAuditTrail && (
                        <Button
                            className={classes.auditTrailButton}
                            onClick={handleAuditTrailDrawerToggle}
                        >
                            {auditTrailLabel}
                        </Button>
                    )}
                </div>
            )}
            {showDrawer && (
                <Drawer
                    anchor="right"
                    open={auditTrailDrawerOpen}
                    onClose={handleAuditTrailDrawerToggle}
                    PaperProps={drawerPaperProps}
                >
                    <AuditTrailViewer 
                        {...props} 
                        auditTrail={auditTrail} 
                        chartUniqueId={chartUniqueId} 
                        handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} 
                    />
                </Drawer>
            )}
        </div>
    );
});

ActionBarViewer.displayName = 'ActionBarViewer';

export default ActionBarViewer